import Image from '@base/Image';
import { pluralize } from '@utils/textHelper';
import { ATTEMPT_STATES, GENERAL_INSTRUCTIONS } from '../../constants';
import {
  ImageWrapper,
  InfoWrapper,
  Section,
  StyledH4,
  StyledLi,
  StyledOl,
  StyledP1
} from './Common';

const renderAttemptStates = () => {
  return (
    <StyledOl>
      {ATTEMPT_STATES.map((info, index) => {
        return (
          <StyledLi
            $listStyle="lower-alpha"
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            <InfoWrapper>
              <ImageWrapper>
                <Image
                  src={info.imageSrc}
                  height={24}
                  width={24}
                  alt={info.alt}
                />
              </ImageWrapper>
              <StyledP1>{info.text}</StyledP1>
            </InfoWrapper>
          </StyledLi>
        );
      })}
    </StyledOl>
  );
};

const General = ({ name = '', timeInMinutes = 0 }) => {
  const renderInfo = (infoText, index) => {
    if (!index) {
      return (
        <StyledP1>
          Total duration of <span className="bold">{name}</span> is{' '}
          {pluralize(timeInMinutes, 'min')}.
        </StyledP1>
      );
    }

    if (index === 2) {
      return (
        <>
          <StyledP1>{infoText}</StyledP1>
          {renderAttemptStates()}
        </>
      );
    }
    return <StyledP1>{infoText}</StyledP1>;
  };

  return (
    <Section>
      <StyledH4>General instructions</StyledH4>
      <StyledOl>
        {GENERAL_INSTRUCTIONS.map((info, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <StyledLi key={index}>{renderInfo(info.text, index)}</StyledLi>
          );
        })}
      </StyledOl>
    </Section>
  );
};

export default General;
